import { TileLayer } from 'leaflet';
//主要用于栅格瓦片的纠偏
const pi = 3.1415926535897932384626;
const a = 6378245.0;
const ee = 0.00669342162296594323;
const x_pi = pi * 3000.0 / 180.0;
const R = 6378137;

function transformLat(x, y) {
    let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));

    ret += (20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0 / 3.0;

    ret += (20.0 * Math.sin(y * pi) + 40.0 * Math.sin(y / 3.0 * pi)) * 2.0 / 3.0;

    ret += (160.0 * Math.sin(y / 12.0 * pi) + 320 * Math.sin(y * pi / 30.0)) * 2.0 / 3.0;

    return ret;
}

function transformLng(x, y) {
    let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));

    ret += (20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) * 2.0 / 3.0;

    ret += (20.0 * Math.sin(x * pi) + 40.0 * Math.sin(x / 3.0 * pi)) * 2.0 / 3.0;

    ret += (150.0 * Math.sin(x / 12.0 * pi) + 300.0 * Math.sin(x / 30.0 * pi)) * 2.0 / 3.0;

    return ret;
}

function transform(lng, lat) {
    let dLat = transformLat(lng - 105.0, lat - 35.0);

    let dLng = transformLng(lng - 105.0, lat - 35.0);

    const radLat = lat / 180.0 * pi;

    let magic = Math.sin(radLat);

    magic = 1 - ee * magic * magic;

    const sqrtMagic = Math.sqrt(magic);

    dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * pi);

    dLng = (dLng * 180.0) / (a / sqrtMagic * Math.cos(radLat) * pi);

    const mgLat = lat + dLat;

    const mgLng = lng + dLng;

    const newCoord = {
        lng: mgLng,
        lat: mgLat
    };

    return newCoord;
}

function gcj02ToWGS84(lng, lat) {
    const coord = transform(lng, lat);

    const lontitude = lng * 2 - coord.lng;

    const latitude = lat * 2 - coord.lat;

    const newCoord = {
        lng: lontitude,
        lat: latitude
    };

    return newCoord;
}

function wgs84ToGCJj02(lng, lat) {
    let dLat = transformLat(lng - 105.0, lat - 35.0);

    let dLng = transformLng(lng - 105.0, lat - 35.0);

    const radLat = lat / 180.0 * pi;

    let magic = Math.sin(radLat);

    magic = 1 - ee * magic * magic;

    const sqrtMagic = Math.sqrt(magic);

    dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * pi);

    dLng = (dLng * 180.0) / (a / sqrtMagic * Math.cos(radLat) * pi);

    const mgLat = lat + dLat;

    const mgLng = lng + dLng;

    const newCoord = {

        lng: mgLng,

        lat: mgLat

    };

    return newCoord;
}


/**
 * 主要用于栅格瓦片的纠偏
 * new TransformLayer({
 *    transform: TransformLayer.WGS84_GCJ02 // TransformLayer.GCJ02_WGS84
 * })
 * 
 */
class TransformLayer extends TileLayer {
    _setZoomTransform(level, center, zoom) {
        const transformed = this.tranformCoord(center);

        const viewHalf = this._map.getSize().divideBy(2);

        const mapProject = this._map.project(transformed, zoom);

        const mapPanePos = this._map._mapPane._leaflet_pos;

        const newPixelOrigin = mapProject.subtract(viewHalf)._add(mapPanePos).round();

        const scale = this._map.getZoomScale(zoom, level.zoom);

        const translate = level.origin.multiplyBy(scale).subtract(newPixelOrigin).round();

        // super._setZoomTransform(level, translate, scale);

        if (L.Browser.any3d) {
            L.DomUtil.setTransform(level.el, translate, scale);
        } else {
            L.DomUtil.setPosition(level.el, translate);
        }
    }

    _getTiledPixelBounds(center) {
        const transformed = this.tranformCoord(center);
        return super._getTiledPixelBounds(transformed);
    }

    tranformCoord(point) {
        if (!point) {
            return point;
        }

        let transformed = { ...point };
        const t = this.options.transform;

        if (t == TransformLayer.WGS84_GCJ02) {
            transformed = gcj02ToWGS84(point.lng, point.lat);
        } else if (t == TransformLayer.GCJ02_WGS84) {
            transformed = wgs84ToGCJj02(point.lng, point.lat);
        }

        return transformed;
    }
}

TransformLayer.GCJ02_WGS84 = 'GCJ02_WGS84';
TransformLayer.WGS84_GCJ02 = 'WGS84_GCJ02';

export default TransformLayer;
